export const isScreenTooSmallForMeaningfulInteraction = (): boolean =>
  Math.min(window.screen.width, window.screen.height) < 768
